/**
 * Stuck Detector
 * 
 * Single Responsibility: Detects when AI is stuck (repeating same question)
 */

export class StuckDetector {
  private lastQuestionAsked: string | null = null;
  private consecutiveSameQuestionCount: number = 0;

  /**
   * Check if AI seems stuck (asking same question repeatedly)
   */
  public checkForStuckState(modelText: string): boolean {
    if (!modelText || modelText.trim().length === 0) {
      return false;
    }

    // Extract potential question from model text
    const questionMatch = modelText.match(/(?:question|ask|tell me|describe|explain)[^.!?]{10,}/i);
    if (!questionMatch) {
      return false;
    }

    const currentQuestionText = questionMatch[0].substring(0, 50).toLowerCase();

    if (
      this.lastQuestionAsked &&
      this.lastQuestionAsked.toLowerCase().includes(currentQuestionText.substring(0, 30))
    ) {
      this.consecutiveSameQuestionCount++;

      if (this.consecutiveSameQuestionCount >= 2) {
        return true;
      }
    } else {
      this.consecutiveSameQuestionCount = 0;
      this.lastQuestionAsked = currentQuestionText;
    }

    return false;
  }

  /**
   * Reset stuck detection state
   */
  public reset(): void {
    this.consecutiveSameQuestionCount = 0;
    this.lastQuestionAsked = null;
  }
}

